import { useCountdown } from 'hooks/draw/useCountdown';
import styles from './DrawCounter.module.css';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface DrawCounterProps {
  targetDate: Date;
}

const DrawCounter = ({ targetDate }: DrawCounterProps) => {
  const { paddedTimeLeft } = useCountdown(targetDate);

  return (
    <div className={styles.container}>
      <span className={` ${styles.nextDraw}`}>Next draw in</span>
      <div className={styles.countdown}>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.days}</span>
          <span className={` ${styles.label}`}>Days</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.hours}</span>
          <span className={` ${styles.label}`}>Hrs</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.minutes}</span>
          <span className={` ${styles.label}`}>Mins</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{paddedTimeLeft.seconds}</span>
          <span className={`${styles.label}`}>Secs</span>
        </div>
      </div>
    </div>
  );
};

export default DrawCounter;
